var unapply = require('ramda/src/unapply');
var identity = require('ramda/src/identity');

/**
 * TODO: TESTS
 * TODO: DOCS
 *
 * @signature *... -> Array<*>
 */
var list = unapply(identity);
module.exports = list;